import React, { useState, useEffect } from 'react';
import AdminLogin from './AdminLogin';
import ChatHistoryViewer from './ChatHistoryViewer';

const AdminPanel: React.FC = () => {
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    // ページ読み込み時にトークンをチェック
    const savedToken = localStorage.getItem('adminToken');
    if (savedToken) {
      setToken(savedToken);
    }
  }, []);

  const handleLoginSuccess = (newToken: string) => {
    setToken(newToken);
  };

  const handleLogout = () => {
    setToken(null);
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      {token ? (
        <ChatHistoryViewer token={token} onLogout={handleLogout} />
      ) : (
        <AdminLogin onLoginSuccess={handleLoginSuccess} />
      )}
    </div>
  );
};

export default AdminPanel;